const state = () => ({
  alert: {
    message: "",
    // message: "Rien à signaler, vous pouvez continuer.",
    errorMessages: [],
  },
  downloading: {
    status: false,
    message: "",
  },
  notifications: [],
  pusherConnected: false,
});

const getters = {
  getAlert: (state) => {
    return state.alert;
  },

  getDownloading: (state) => {
    return state.downloading;
  },

  getNotifications: (state) => {
    return state.notifications;
  },

  isPusherConnected: (state) => {
    return state.pusherConnected;
  },
};

const actions = {
  async store({ commit }, data) {
    // this._vm.$notify("text");

    commit("setAlert", data);
    setTimeout(function () {
      commit("setAlert", {
        message: "",
        // message: "Rien à signaler, vous pouvez continuer.",
        errorMessages: [],
      });
    }, 10000);
  },

  async storeDownloading({ commit }, data) {
    console.log(data);

    commit("setDownloading", data);
    setTimeout(function () {
      commit("setDownloading", {
        message: "",
        // message: "Rien à signaler, vous pouvez continuer.",
      });
    }, 5000);
  },

  addNotification({ commit }, notification) {
    commit("addNotification", notification);
    // Auto-remove after 10 seconds
    setTimeout(() => {
      commit("removeNotification", notification.id);
    }, 10000);
  },

  setPusherConnected({ commit }, status) {
    commit("setPusherConnected", status);
  },
};

const mutations = {
  async setAlert(state, data) {
    await (state.alert = data);
  },

  async setDownloading(state, data) {
    await (state.downloading = data);
  },

  addNotification(state, notification) {
    const id = Date.now() + Math.random();
    state.notifications.push({
      id,
      ...notification,
      timestamp: new Date(),
    });
  },

  removeNotification(state, id) {
    state.notifications = state.notifications.filter((n) => n.id !== id);
  },

  setPusherConnected(state, status) {
    state.pusherConnected = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
